import { render, staticRenderFns } from "./AprovalModal.vue?vue&type=template&id=0608120d&scoped=true"
import script from "./AprovalModal.vue?vue&type=script&lang=js"
export * from "./AprovalModal.vue?vue&type=script&lang=js"
import style0 from "./AprovalModal.vue?vue&type=style&index=0&id=0608120d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0608120d",
  null
  
)

export default component.exports